import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { loadingAction } from 'store/globalState/global';
import { leaveThinkTank, proposeContent, getProposedContent } from 'components/ThinkTanks/modules/actions';
import { leaveThinkChat, getMyThinkChats } from 'modules/think-seeds/actions';
import { killSeed, fetchUserChats } from 'modules/chats';
import { killThinkSeed, launchThinkTank } from 'routes/Upgrade/modules/actions';
import ThemeTableDetail from '../components';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.themeTableDetail,
    actualUser: state.session.user,
    app: state.app,
    userElements: state.elements.selectedElements,
    narratives: state.narratives.list,
    myThinkChatsList: state.thinkChats.myThinkChatsList,
    proposedContent: state.thinkTanks.proposedContent,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showLoading: bindActionCreators(loadingAction, dispatch),
    leaveThinkTank: bindActionCreators(leaveThinkTank, dispatch),
    proposeContent: bindActionCreators(proposeContent, dispatch),
    getProposedContent: bindActionCreators(getProposedContent, dispatch),
    leaveThinkChat: bindActionCreators(leaveThinkChat, dispatch),
    getMyThinkChats: bindActionCreators(getMyThinkChats, dispatch),
    killThinkSeed: bindActionCreators(killThinkSeed, dispatch),
    launchThinkTank: bindActionCreators(launchThinkTank, dispatch),
    killSeed: bindActionCreators(killSeed, dispatch),
    getChats: bindActionCreators(fetchUserChats, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ThemeTableDetail));



// WEBPACK FOOTER //
// ./src/components/ThemeTableDetail/container/index.js